import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import '../../entity-forms.css';

export default function VehicleModel() {
  const API_URL = process.env.REACT_APP_API_URL;

  const [data, setdata]             = useState([]);
  const [isload, setisload]         = useState(true);
  const [search, setSearch]         = useState('');

  const initForm = { user: sessionStorage.getItem('userid'), status: 'Active' };
  const [form, setForm]             = useState(initForm);
  const [isEdit, setIsEdit]         = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [msg, setMsg]               = useState('');
  const [errMsg, setErrMsg]         = useState('');

  useEffect(() => { loadList(); }, []);

  const loadList = async () => {
    setisload(true);
    try {
      const res = await axios.get(`${API_URL}shypvdriverapp/vehicleModel/getModels`);
      if (res.data?.data) setdata(res.data.data);
    } catch {}
    setisload(false);
  };

  const openAdd  = () => { setForm(initForm); setIsEdit(false); setMsg(''); setErrMsg(''); setDrawerOpen(true); };
  const openEdit = (row) => { setForm({ ...row }); setIsEdit(true); setMsg(''); setErrMsg(''); setDrawerOpen(true); };
  const closeDrawer = () => { setDrawerOpen(false); setForm(initForm); };

  const buildPayload = () => ({
    vehicle_model_name: form.vehicle_model_name,
    veh_type:           form.veh_type,
    description:        form.description || '',
    fleet_type:         form.fleet_type,
    fuel_type:          form.fuel_type,
    min_volume:   parseInt(form.min_volume,  10) || 0,
    max_volume:   parseInt(form.max_volume,  10) || 0,
    min_task:     parseInt(form.min_task,    10) || 0,
    max_task:     parseInt(form.max_task,    10) || 0,
    side:               form.side || '',
    load_dur:     parseInt(form.load_dur,    10) || 0,
    unload_dur:   parseInt(form.unload_dur,  10) || 0,
    is_cold:      form.is_cold  ? 1 : 0,
    is_freeze:    form.is_freeze ? 1 : 0,
    updatedBy:    sessionStorage.getItem('userid'),
    status:       'Active',
  });

  const handleSubmit = async () => {
    if (!form.vehicle_model_name || !form.veh_type || !form.fleet_type || !form.fuel_type) {
      setMsg('Please fill all required fields (*)'); return;
    }
    setMsg('');
    try {
      const payload = buildPayload();
      if (isEdit) payload.vehicle_model_code = form.vehicle_model_code;
      const url = isEdit
        ? `${API_URL}shypvdriverapp/vehicleModel/updateModel`
        : `${API_URL}shypvdriverapp/vehicleModel/createModel`;
      const res = await axios.post(url, payload, { headers: { 'Content-Type': 'application/json' } });
      if (res.data.success) { closeDrawer(); loadList(); }
      else setMsg('Operation failed. Please try again.');
    } catch (e) { setErrMsg('Server error: ' + (e.response?.data?.message || e.message)); }
  };

  const handleDelete = async () => {
    if (!selectedIds.length) return;
    if (!window.confirm(`Delete ${selectedIds.length} model(s)?`)) return;
    try {
      for (const code of selectedIds) {
        await axios.delete(`${API_URL}shypvdriverapp/vehicleModel/deleteModel`, {
          headers: { 'Content-Type': 'application/json' },
          data: { vehicle_model_code: code },
        });
      }
      setSelectedIds([]); loadList();
    } catch { setErrMsg('Error deleting model'); }
  };

  const toggleSelect = (code, row) => {
    setSelectedIds(prev => {
      if (prev.includes(code)) { const next = prev.filter(x => x !== code); if (!next.length) setForm(initForm); return next; }
      setForm(row); return [...prev, code];
    });
  };

  const filtered = data.filter(r =>
    !search ||
    r.vehicle_model_name?.toLowerCase().includes(search.toLowerCase()) ||
    String(r.vehicle_model_code).includes(search)
  );

  const role = sessionStorage.getItem('role');
  const canDelete = role === 'super_admin' || role === 'admin';

  return (
    <div style={{ fontFamily:"'Poppins', sans-serif" }}>
      <div className="em-action-bar">
        <div className="em-search-wrap">
          <i className="fa fa-search" />
          <input className="em-search" placeholder="Search models…" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <button className="em-btn em-btn-primary" onClick={openAdd}><i className="fa fa-plus" /> Add Model</button>
        {selectedIds.length === 1 && (
          <button className="em-btn em-btn-warning" onClick={() => openEdit(form)}><i className="fa fa-pencil" /> Edit</button>
        )}
        {selectedIds.length > 0 && canDelete && (
          <button className="em-btn em-btn-danger" onClick={handleDelete}><i className="fa fa-trash" /> Delete ({selectedIds.length})</button>
        )}
        <CSVLink data={filtered} filename="vehicle-models.csv" className="em-btn em-btn-csv"><i className="fa fa-download" /> Export</CSVLink>
        {errMsg && <span className="em-msg-error">{errMsg}</span>}
      </div>

      <div style={{ overflowX:'auto' }}>
        <table className="em-table">
          <thead>
            <tr>
              <th className="em-col-h" style={{ width:36 }}>
                <input type="checkbox" onChange={e => setSelectedIds(e.target.checked ? filtered.map(r => r.vehicle_model_code) : [])}
                  checked={selectedIds.length > 0 && selectedIds.length === filtered.length} />
              </th>
              {['Code','Name','Type','Fleet','Fuel','Max Task','Max Vol','Cold','Freeze','Actions'].map(h => <th key={h} className="em-col-h">{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {isload ? (
              <tr><td colSpan={11} style={{ textAlign:'center', padding:40, color:'#94a3b8' }}>
                <i className="fa fa-spinner fa-spin" style={{ fontSize:22, display:'block', marginBottom:8 }} />Loading models…
              </td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={11} style={{ textAlign:'center', padding:40, color:'#94a3b8' }}>No vehicle models found</td></tr>
            ) : filtered.map((row, i) => {
              const sel = selectedIds.includes(row.vehicle_model_code);
              return (
                <tr key={row.vehicle_model_code} className={`em-tr${sel?' selected':''}`}
                  style={{ animation:`emFadeUp 0.3s ${Math.min(i,20)*0.018}s ease-out both` }}>
                  <td className="em-td"><input type="checkbox" checked={sel} onChange={() => toggleSelect(row.vehicle_model_code, row)} /></td>
                  <td className="em-td" style={{ color:'#64748b', fontSize:12 }}>{row.vehicle_model_code}</td>
                  <td className="em-td" style={{ fontWeight:600 }}>{row.vehicle_model_name}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.veh_type}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.fleet_type}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.fuel_type}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.max_task}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.max_volume}</td>
                  <td className="em-td">
                    <span className={`em-badge ${row.is_cold?'em-badge-blue':'em-badge-grey'}`}>{row.is_cold?'Yes':'No'}</span>
                  </td>
                  <td className="em-td">
                    <span className={`em-badge ${row.is_freeze?'em-badge-blue':'em-badge-grey'}`}>{row.is_freeze?'Yes':'No'}</span>
                  </td>
                  <td className="em-td">
                    <button className="em-btn em-btn-ghost" style={{ padding:'5px 10px', fontSize:11 }} onClick={() => openEdit(row)}>
                      <i className="fa fa-pencil" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div style={{ padding:'10px 16px', background:'#f8fafc', borderTop:'1px solid #e8edf2', fontSize:12, color:'#94a3b8', fontWeight:600 }}>
        {filtered.length} model{filtered.length!==1?'s':''}
      </div>

      {drawerOpen && (
        <>
          <div className="em-overlay" onClick={closeDrawer} />
          <div className="em-drawer">
            <div className="em-drawer-header">
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                  <div style={{ width:36, height:36, borderRadius:11, background:'rgba(255,255,255,0.12)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <i className="fa fa-car" style={{ color:'#fff', fontSize:16 }} />
                  </div>
                  <div>
                    <p className="em-drawer-title">{isEdit ? 'Edit Vehicle Model' : 'Add New Vehicle Model'}</p>
                    <p className="em-drawer-sub">{isEdit ? `Code: ${form.vehicle_model_code}` : 'Fill in the model details below'}</p>
                  </div>
                </div>
                <button onClick={closeDrawer} style={{ background:'rgba(255,255,255,0.1)', border:'none', borderRadius:10, width:30, height:30, cursor:'pointer', color:'#fff', fontSize:18, display:'flex', alignItems:'center', justifyContent:'center' }}>×</button>
              </div>
            </div>
            <div className="em-drawer-body">
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Model Name<span className="em-req">*</span></label>
                  <input className="em-field" value={form.vehicle_model_name||''} placeholder="e.g. Toyota Hiace L2H2"
                    onChange={e => setForm(p => ({ ...p, vehicle_model_name: e.target.value }))} />
                </div>
                <div className="em-form-row">
                  <label className="em-label">Vehicle Type<span className="em-req">*</span></label>
                  <input className="em-field" value={form.veh_type||''} placeholder="e.g. Van, Truck"
                    onChange={e => setForm(p => ({ ...p, veh_type: e.target.value }))} />
                </div>
              </div>
              <div className="em-form-row">
                <label className="em-label">Description</label>
                <input className="em-field" value={form.description||''} placeholder="Optional description"
                  onChange={e => setForm(p => ({ ...p, description: e.target.value }))} />
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Fleet Type<span className="em-req">*</span></label>
                  <select className="em-field" value={form.fleet_type||''} onChange={e => setForm(p => ({ ...p, fleet_type: e.target.value }))}>
                    <option value="">— Select —</option>
                    <option value="Own">Own</option>
                    <option value="Thirdparty">Thirdparty</option>
                  </select>
                </div>
                <div className="em-form-row">
                  <label className="em-label">Fuel Type<span className="em-req">*</span></label>
                  <select className="em-field" value={form.fuel_type||''} onChange={e => setForm(p => ({ ...p, fuel_type: e.target.value }))}>
                    <option value="">— Select —</option>
                    <option value="Petrol">Petrol</option>
                    <option value="Diesel">Diesel</option>
                    <option value="Electric">Electric</option>
                    <option value="Hybrid">Hybrid</option>
                  </select>
                </div>
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Loading Duration (min)</label>
                  <input className="em-field" type="number" value={form.load_dur||''} placeholder="0"
                    onChange={e => setForm(p => ({ ...p, load_dur: e.target.value }))} />
                </div>
                <div className="em-form-row">
                  <label className="em-label">Unloading Duration (min)</label>
                  <input className="em-field" type="number" value={form.unload_dur||''} placeholder="0"
                    onChange={e => setForm(p => ({ ...p, unload_dur: e.target.value }))} />
                </div>
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Min Task</label>
                  <input className="em-field" type="number" value={form.min_task||''} placeholder="0"
                    onChange={e => setForm(p => ({ ...p, min_task: e.target.value }))} />
                </div>
                <div className="em-form-row">
                  <label className="em-label">Max Task</label>
                  <input className="em-field" type="number" value={form.max_task||''} placeholder="0"
                    onChange={e => setForm(p => ({ ...p, max_task: e.target.value }))} />
                </div>
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Min Volume</label>
                  <input className="em-field" type="number" value={form.min_volume||''} placeholder="0"
                    onChange={e => setForm(p => ({ ...p, min_volume: e.target.value }))} />
                </div>
                <div className="em-form-row">
                  <label className="em-label">Max Volume</label>
                  <input className="em-field" type="number" value={form.max_volume||''} placeholder="0"
                    onChange={e => setForm(p => ({ ...p, max_volume: e.target.value }))} />
                </div>
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Cold Chain</label>
                  <select className="em-field" value={form.is_cold?'yes':'no'} onChange={e => setForm(p => ({ ...p, is_cold: e.target.value==='yes' }))}>
                    <option value="no">No</option>
                    <option value="yes">Yes</option>
                  </select>
                </div>
                <div className="em-form-row">
                  <label className="em-label">Deep Freeze</label>
                  <select className="em-field" value={form.is_freeze?'yes':'no'} onChange={e => setForm(p => ({ ...p, is_freeze: e.target.value==='yes' }))}>
                    <option value="no">No</option>
                    <option value="yes">Yes</option>
                  </select>
                </div>
              </div>
              <div className="em-form-row" style={{ maxWidth:240 }}>
                <label className="em-label">Loading Side</label>
                <select className="em-field" value={form.side||''} onChange={e => setForm(p => ({ ...p, side: e.target.value }))}>
                  <option value="">— Select —</option>
                  <option value="Left">Left</option>
                  <option value="Right">Right</option>
                  <option value="Rear">Rear</option>
                  <option value="Both">Both</option>
                </select>
              </div>
              {msg    && <p className="em-msg-error">{msg}</p>}
              {errMsg && <p className="em-msg-error">{errMsg}</p>}
            </div>
            <div className="em-drawer-footer">
              <button className="em-dismiss-btn" onClick={closeDrawer}>Cancel</button>
              <button className="em-save-btn" onClick={handleSubmit}>
                <i className="fa fa-check" style={{ marginRight:6 }} />{isEdit?'Update Model':'Save Model'}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
